import { Component } from '@angular/core';
import {IonicPage, NavController, NavParams, MenuController} from 'ionic-angular';

import { FileTransfer, FileTransferObject } from '@ionic-native/file-transfer';
import { File } from '@ionic-native/file';

import { FileOpener } from '@ionic-native/file-opener';

import { UserProvider } from '../../providers/user';
import { TeamappProvider } from '../../providers/teamapp';
import { LoadingProvider } from '../../providers/loading';
/**
 * Generated class for the CmsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-cms',
  templateUrl: 'cms.html',
})
export class CmsPage {

  title: string = 'CMS';
  pdf_path: string = 'https://app.fw-wesling.de/uploads/documents/';

  page_boxes: any;
  page_id: number;

  disable_menu: boolean = false;
  disable_user_menu: boolean = false;

  enable_guest_menu: boolean = false;
  constructor(public navCtrl: NavController, public navParams: NavParams, public userProvider: UserProvider, public teamappProvider: TeamappProvider, private transfer: FileTransfer, private file: File, private fileOpener: FileOpener, public loadingProvider: LoadingProvider, public menuCtrl: MenuController) {

    this.page_id = this.navParams.get("page");
    this.title = this.navParams.get("title");
    this.disable_menu = this.navParams.get("disable_menu");
    this.disable_user_menu = this.navParams.get("disable_user_menu");
    this.enable_guest_menu = this.navParams.get("enable_guest_menu");

    console.log(this.page_id);
    this.loadPage();

  }


  ionViewDidLoad() {
    console.log('ionViewDidLoad CmsPage');
  }


  loadPage() {
    this.teamappProvider.http_request('page='+this.page_id, 'cms', false, true).then(data => {

        let cmsData: any = data;
        if(!cmsData.error) {
            this.page_boxes = cmsData;
        }
    });
  }

  ionViewDidEnter() {
      // the root left menu should be disabled on this page
      if(this.enable_guest_menu == true) {
        this.menuCtrl.enable(false, 'main-menu');
        this.menuCtrl.enable(true, 'guest-menu');
      }

  }

  ionViewWillLeave() {
      if(this.enable_guest_menu == true) {
          this.menuCtrl.enable(true, 'main-menu');
          this.menuCtrl.enable(false, 'guest-menu');
      }
  }

  openPDF(document_name,box_id, fileUrl){
    const fileTransfer: FileTransferObject = this.transfer.create();
    console.log(this.pdf_path + fileUrl);
    console.log(this.file.dataDirectory + document_name+'-'+box_id+'.pdf');
    this.loadingProvider.show();
    fileTransfer.download(this.pdf_path + fileUrl, this.file.dataDirectory + document_name+'-'+box_id+'.pdf').then((entry) => {
        this.fileOpener.open(entry.toURL(), 'application/pdf')
            .then(() => console.log('File is opened'))
            .catch(e => console.log('Error opening file', e));
            this.loadingProvider.hide();
    }, (error) => {
        this.loadingProvider.hide();
    });
  }

  goToPage(pageId: any, page_title: string) {
    this.navCtrl.push(CmsPage,{page: pageId, disable_menu: this.disable_menu, disable_user_menu: this.disable_user_menu, enable_guest_menu: this.enable_guest_menu, title: page_title});
  }

  refreshPage(event:any) {
      this.loadPage();
      event.complete();
  }
}



// WEBPACK FOOTER //
// ./src/pages/cms/cms.ts